"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
/*
  Out of scope according to https://elsevier.atlassian.net/browse/E3D4M-30804 ticket
  TODO: implement Drag'n'Drop functionality

  import Draggable from 'molecules/Draggable';
 */
const Draggable_1 = __importDefault(require("../Draggable/Draggable"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const react_2 = __importDefault(require("react"));
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const molecules_1 = require("..");
const providers_1 = require("../../providers");
// eslint-disable-next-line max-lines-per-function
function StickyCard({ identifier, rect, children, className, canDrag, onClick = lodash_1.noop, onDoubleClick = lodash_1.noop, onDragging = lodash_1.noop, onDragEnd = lodash_1.noop, onResizing = lodash_1.noop, onResizeEnd = lodash_1.noop, onClickOutside = lodash_1.noop, }) {
    var _a, _b;
    const [isDragged, setDragged] = (0, react_1.useState)(false);
    const [{ activeStickyID }, dispatch] = (0, providers_1.useToolsModeContext)();
    const windowSize = (0, ui_1.useScreenSize)();
    const [originalWindowSize] = (0, react_1.useState)(windowSize);
    const selectedType = (0, hooks_1.useSelectedType)();
    const selectedID = (0, hooks_1.useSelectedID)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const bridge = (0, bridge_1.useBridge)();
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const sticky = stickies.find(s => s.identifier === identifier);
    const containerRef = (0, react_1.useRef)(null);
    const dragRef = (0, react_1.useRef)(false);
    const [position, setPosition] = (0, react_1.useState)({ x: rect === null || rect === void 0 ? void 0 : rect.x, y: rect === null || rect === void 0 ? void 0 : rect.y });
    const { isMobile } = (0, device_1.usePlatform)();
    const isInLectureMode = localStorage.getItem('lectureMode') === 'true'; //set in the legacy code
    const size = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (isMobile && sticky) {
            const screenSizeScale = windowSize.height / 768;
            const width = (sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.width) * screenSizeScale;
            const height = (sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.height) * screenSizeScale;
            return { width, height };
        }
        return {
            width: (_a = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.width) !== null && _a !== void 0 ? _a : 0,
            height: (_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.height) !== null && _b !== void 0 ? _b : 0,
        };
    }, [isMobile, sticky, windowSize]);
    const onDelete = () => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().removeSticky(identifier);
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateUndoRedoHistory();
        if (selectedType !== bridge_schema_1.ToolType.None &&
            selectedType !== bridge_schema_1.ToolType.StickyImage &&
            selectedType !== bridge_schema_1.ToolType.StickyVideo) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolSelect(bridge_schema_1.ToolType.None);
            navigate(-1);
        }
    };
    const onClickHandler = (0, react_1.useCallback)(() => {
        if (!dragRef.current) {
            onClick();
            dispatch((0, hooks_1.setActiveStickyID)(identifier));
            bridge === null || bridge === void 0 ? void 0 : bridge.stickySelect(identifier);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifier, onClick]);
    const onDragAction = (0, react_1.useCallback)((action, delta) => {
        var _a, _b;
        if (!dragRef.current && action === ui_1.ActionType.DRAG) {
            dispatch((0, hooks_1.setActiveStickyID)(identifier));
            setDragged(true);
            onDragging();
        }
        dragRef.current = action === ui_1.ActionType.DRAG;
        const defaultX = (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : 0;
        const defaultY = (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : 0;
        const newPosition = {
            x: defaultX + delta.x,
            y: defaultY + delta.y,
        };
        if (action === ui_1.ActionType.MOUSE_UP) {
            if (newPosition.x !== (sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.x) ||
                newPosition.y !== (sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.y)) {
                const updatedStickyRect = Object.assign(Object.assign({}, sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect), newPosition);
                bridge === null || bridge === void 0 ? void 0 : bridge.stickyUpdate({
                    identifier,
                    position: newPosition,
                });
                tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
                    identifier,
                    stickyRect: updatedStickyRect,
                });
                tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateUndoRedoHistory();
            }
            setPosition(newPosition);
            setDragged(false);
            onDragEnd();
        }
    }, [
        identifier,
        onDragging,
        onDragEnd,
        position,
        sticky,
        tools,
        bridge,
        dispatch,
    ]);
    const onResizeAction = (0, react_1.useCallback)((action, newSize) => {
        if (!sticky || !tools)
            return;
        const { width: originalWidth, height: originalHeight } = sticky.stickyRect;
        let adjustedWidth = newSize.width;
        let adjustedHeight = newSize.height;
        // Apply aspect ratio logic only for Image and Video stickies
        if (sticky.type === bridge_schema_1.ToolType.StickyImage ||
            sticky.type === bridge_schema_1.ToolType.StickyVideo) {
            if (newSize.width !== originalWidth) {
                adjustedHeight = (newSize.width * originalHeight) / originalWidth;
            }
            else if (newSize.height !== originalHeight) {
                adjustedWidth = (newSize.height * originalWidth) / originalHeight;
            }
        }
        if (action === ui_1.ActionType.DRAG) {
            onResizing(newSize);
        }
        if (action === ui_1.ActionType.MOUSE_UP) {
            const updatedStickyRect = {
                width: adjustedWidth,
                height: adjustedHeight,
            };
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
                identifier,
                stickyRect: updatedStickyRect,
            });
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateUndoRedoHistory();
            onResizeEnd(newSize);
        }
    }, [onResizing, identifier, onResizeEnd, tools, sticky]);
    (0, ui_1.useDoubleClick)(containerRef, true, onClickHandler, onDoubleClick);
    (0, ui_1.useOutsideClick)(containerRef, onClickOutside, ['.tools-header']);
    const isActive = activeStickyID === identifier;
    const isSelected = selectedID === identifier;
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, "$size": size, "$active": isActive, "$position": {
            x: (((_a = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.x) !== null && _a !== void 0 ? _a : 0) / originalWindowSize.width) * 100,
            y: (((_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.y) !== null && _b !== void 0 ? _b : 0) / originalWindowSize.height) * 100,
        }, "$dragged": isDragged, "$selected": isSelected, className: className, disabled: !canDrag, onDragAction: onDragAction, "data-e2e": 'StickyCard_Container', children: [children, (0, jsx_runtime_1.jsx)(StyledDeleteStickyButton, { "$visible": isMobile && isInLectureMode ? false : isSelected, onClick: onDelete, "data-e2e": 'StickyCard_StyledDeleteStickyButton' }), (0, jsx_runtime_1.jsx)(molecules_1.StickyCardResizer, { size: size, visible: isMobile && isInLectureMode ? false : isSelected, onResizeAction: onResizeAction, diagonalResizing: (sticky === null || sticky === void 0 ? void 0 : sticky.type) === bridge_schema_1.ToolType.StickyImage ||
                    (sticky === null || sticky === void 0 ? void 0 : sticky.type) === bridge_schema_1.ToolType.StickyVideo, "data-e2e": 'StickyCard_StickyCardResizer' })] }));
}
exports.default = react_2.default.memo(StickyCard);
const Container = (0, styled_components_1.default)(Draggable_1.default) `
  top: ${({ $position }) => $position.y}vh;
  left: ${({ $position }) => $position.x}vw;

  display: flex;

  box-sizing: border-box;

  width: ${({ $size }) => $size.width}px;
  min-width: 20vh;
  height: ${({ $size }) => $size.height}px;
  min-height: 60px;

  padding: 15px;

  background: ${({ theme }) => theme.backgroundSecondary};

  border: 1px solid
    ${({ theme, $selected }) => $selected ? theme.text : theme.backgroundSecondary};

  transition: border-color 0.2s;

  /* 
    dragged sticky must be must be over all, 
    selected must be over all except dragged, 
    last active sticky must be over all except dragging and selected 
   */

  ${({ $selected, $active, $dragged }) => ($selected || $active || $dragged) &&
    (0, styled_components_1.css) `
      z-index: ${$dragged ? 3 : $active ? 1 : 2};
    `};
`;
const StyledDeleteStickyButton = (0, styled_components_1.default)(atoms_1.DeleteStickyButton) `
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};

  transition: opacity 0.2s;

  pointer-events: ${({ $visible }) => ($visible ? 'all' : 'none')};
`;
